import { useEffect, useState } from "react";

export default function Loader() {
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    return !sessionStorage.getItem("ts_booted");
  });
  const [phase, setPhase] = useState("counting"); // counting -> reveal -> done

  useEffect(() => {
    if (!show) return;
    document.body.style.overflow = "hidden";
    const t1 = setTimeout(() => setPhase("reveal"), 1400);
    const t2 = setTimeout(() => {
      setShow(false);
      sessionStorage.setItem("ts_booted", "1");
      document.body.style.overflow = "";
    }, 2400);
    return () => {
      clearTimeout(t1); clearTimeout(t2);
      document.body.style.overflow = "";
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      data-testid="boot-loader"
      className={`fixed inset-0 z-[200] bg-ink flex items-center justify-center transition-opacity duration-500 ${
        phase === "reveal" ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      <div className="absolute inset-0 noise opacity-50 pointer-events-none" />
      <div className="relative flex flex-col items-center px-6">
        <div className="flex items-center gap-3 text-blood font-mono text-[10px] tracking-[0.4em] mb-6">
          <span className="w-2 h-2 bg-blood animate-pulse" />
          BOOTING / DROP 001 / 永遠の遺産
          <span className="w-2 h-2 bg-blood animate-pulse" />
        </div>
        <div className="font-anton uppercase text-bone text-[14vw] sm:text-[10vw] leading-[0.85] tracking-tighter text-center">
          TOXIC
          <span className="text-blood">/</span>
          STREET
        </div>
        <div className="mt-4 font-marker text-bone text-xl sm:text-2xl">
          discipline over <span className="text-blood">everything</span>
        </div>
        <div className="mt-8 w-64 h-[2px] bg-white/10 overflow-hidden">
          <div className="h-full bg-blood animate-[marquee_1.4s_linear_forwards]" style={{ animation: "loadbar 1.4s linear forwards" }} />
        </div>
      </div>
      <style>{`@keyframes loadbar { from { width: 0%; } to { width: 100%; } }`}</style>
    </div>
  );
}
